import { render, staticRenderFns } from "./ReportPreview.vue?vue&type=template&id=67d66874&scoped=true&"
import script from "./ReportPreview.vue?vue&type=script&lang=js&"
export * from "./ReportPreview.vue?vue&type=script&lang=js&"
import style0 from "./ReportPreview.vue?vue&type=style&index=0&id=67d66874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d66874",
  null
  
)

export default component.exports